import { render, staticRenderFns } from "./randomQuestionSelect.vue?vue&type=template&id=a0ae0402&scoped=true&"
import script from "./randomQuestionSelect.vue?vue&type=script&lang=js&"
export * from "./randomQuestionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ae0402",
  null
  
)

export default component.exports